import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { logout } from "../../redux/features/authSlice";
import EmptyModal from "./EmptyModal";

const Header = () => {
   const { isLoggedIn } = useSelector((state) => state.auth);
   const [isOpen, setIsOpen] = useState(false);

   const distpatch = useDispatch();
   const handleLogout = () => {
      distpatch(logout());
   };
   return (
      <>
         <div>
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
               <ul className="navbar-nav">
                  <li className="nav-item">
                     <a
                        className="nav-link"
                        data-widget="pushmenu"
                        href="#"
                        role="button"
                     >
                        <i className="fas fa-bars" />
                     </a>
                  </li>
                  <li className="nav-item d-none d-sm-inline-block">
                     <Link to="/dashboard" className="nav-link">
                        Home
                     </Link>
                  </li>
                  {/* <li className="nav-item d-none d-sm-inline-block">
                     <a href="#" className="nav-link">
                        Contact
                     </a>
                  </li> */}
               </ul>
               <ul className="navbar-nav ml-auto">
                  {/* <li className="nav-item">
                     <a
                        className="nav-link"
                        data-widget="navbar-search"
                        href="#"
                        role="button"
                     >
                        <i className="fas fa-search" />
                     </a>
                     <div className="navbar-search-block">
                        <form className="form-inline">
                           <div className="input-group input-group-sm">
                              <input
                                 className="form-control form-control-navbar"
                                 type="search"
                                 placeholder="Search"
                                 aria-label="Search"
                              />
                              <div className="input-group-append">
                                 <button className="btn btn-navbar" type="submit">
                                    <i className="fas fa-search" />
                                 </button>
                                 <button
                                    className="btn btn-navbar"
                                    type="button"
                                    data-widget="navbar-search"
                                 >
                                    <i className="fas fa-times" />
                                 </button>
                              </div>
                           </div>
                        </form>
                     </div>
                  </li> */}
                  {/* <li className="nav-item dropdown">
                     <a className="nav-link" data-toggle="dropdown" href="#">
                        <i className="far fa-comments" />
                        <span className="badge badge-danger navbar-badge">3</span>
                     </a>
                     <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                        <a href="#" className="dropdown-item">
                           <div className="media">
                              <img
                                 src="dist/img/user1-128x128.jpg"
                                 alt="User Avatar"
                                 className="img-size-50 mr-3 img-circle"
                              />
                              <div className="media-body">
                                 <h3 className="dropdown-item-title">
                                    Brad Diesel
                                    <span className="float-right text-sm text-danger">
                                       <i className="fas fa-star" />
                                    </span>
                                 </h3>
                                 <p className="text-sm">Call me whenever you can...</p>
                                 <p className="text-sm text-muted">
                                    <i className="far fa-clock mr-1" /> 4 Hours Ago
                                 </p>
                              </div>
                           </div>
                        </a>
                        <div className="dropdown-divider" />
                        <a href="#" className="dropdown-item">
                           <div className="media">
                              <img
                                 src="dist/img/user8-128x128.jpg"
                                 alt="User Avatar"
                                 className="img-size-50 img-circle mr-3"
                              />
                              <div className="media-body">
                                 <h3 className="dropdown-item-title">
                                    John Pierce
                                    <span className="float-right text-sm text-muted">
                                       <i className="fas fa-star" />
                                    </span>
                                 </h3>
                                 <p className="text-sm">I got your message bro</p>
                                 <p className="text-sm text-muted">
                                    <i className="far fa-clock mr-1" /> 4 Hours Ago
                                 </p>
                              </div>
                           </div>
                        </a>
                     </div>
                  </li> */}
                  {/* <li className="nav-item">
                     <a
                        className="nav-link"
                        data-widget="fullscreen"
                        href="#"
                        role="button"
                     >
                        <i className="fas fa-expand-arrows-alt" />
                     </a>
                  </li> */}
                  <li className="nav-item" title="Logout">
                     <a
                        className="nav-link"
                        href="#"
                        role="button"
                        onClick={() => setIsOpen(true)}
                     >
                        <i class="fas fa-power-off"></i>
                     </a>
                  </li>
               </ul>
            </nav>
         </div>

         <EmptyModal showModal={isOpen} handleCloseModal={() => setIsOpen(false)}>
            <div className="d-flex flex-column align-items-center pb-3">
               <p className="h3">Are you sure you want to logout?</p>
               <div className="d-flex mt-3">
                  <button
                     className="btn btn-danger mr-3"
                     style={{ width: "120px" }}
                     onClick={handleLogout}
                  >
                     Yes
                  </button>
                  <button
                     className="btn btn-success"
                     style={{ width: "120px" }}
                     onClick={() => setIsOpen(false)}
                  >
                     No
                  </button>
               </div>
            </div>
         </EmptyModal>
      </>
   );
};
export default Header;
